import { Instagram, MessageCircle } from "lucide-react";
import { scrollToId } from "@/lib/scroll";
import { PrivacyLink } from "@/components/PrivacyModal";

const NAV = [
  { id: "solucao", label: "Solução" },
  { id: "calculadora", label: "Calculadora" },
  { id: "como-funciona", label: "Como funciona" },
  { id: "segmentos", label: "Segmentos" },
  { id: "planos", label: "Planos" },
  { id: "faq", label: "FAQ" },
];

export default function Footer() {
  return (
    <footer data-testid="footer" className="relative overflow-hidden bg-navy text-white">
      <div className="mx-auto max-w-7xl px-5 pb-10 pt-20 lg:px-10">
        <div className="flex flex-col gap-12 border-b border-white/10 pb-14 lg:flex-row lg:items-start lg:justify-between">
          <div className="max-w-sm">
            <button
              data-testid="footer-logo"
              onClick={() => scrollToId("inicio")}
              aria-label="CliniAtiva — voltar ao início"
              className="block"
            >
              <img src="/logo-dark.png" alt="CliniAtiva — tecnologia" className="h-11 w-auto" />
            </button>
            <p className="mt-4 text-sm leading-relaxed text-sage/70">
              Sua equipe atende pessoas. A CliniAtiva cuida do resto. Automação inteligente de
              atendimento e agendamento via WhatsApp.
            </p>
            <div className="mt-6 flex gap-3">
              <a
                data-testid="footer-instagram-link"
                href="https://instagram.com/cliniativa"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram da CliniAtiva"
                className="flex h-11 w-11 items-center justify-center rounded-full border border-white/15 text-sage transition-[border-color,color,transform] duration-300 hover:scale-105 hover:border-turquoise hover:text-turquoise"
              >
                <Instagram className="h-5 w-5" />
              </a>
              <a
                data-testid="footer-whatsapp-link"
                href="https://wa.me/558594032594"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="WhatsApp da CliniAtiva"
                className="flex h-11 w-11 items-center justify-center rounded-full border border-white/15 text-sage transition-[border-color,color,transform] duration-300 hover:scale-105 hover:border-turquoise hover:text-turquoise"
              >
                <MessageCircle className="h-5 w-5" />
              </a>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-10 sm:grid-cols-3">
            <div>
              <p className="font-mono2 text-[10px] uppercase tracking-[0.3em] text-sage/50">Navegação</p>
              <ul className="mt-5 space-y-3">
                {NAV.map((n) => (
                  <li key={n.id}>
                    <button
                      data-testid={`footer-nav-${n.id}`}
                      onClick={() => scrollToId(n.id)}
                      className="text-sm text-sage/80 transition-colors duration-300 hover:text-turquoise"
                    >
                      {n.label}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <p className="font-mono2 text-[10px] uppercase tracking-[0.3em] text-sage/50">Contato</p>
              <ul className="mt-5 space-y-3 text-sm text-sage/80">
                <li>
                  <a data-testid="footer-phone-link" href="https://wa.me/558594032594" target="_blank" rel="noopener noreferrer" className="transition-colors duration-300 hover:text-turquoise">
                    +55 85 9403-2594
                  </a>
                </li>
                <li>
                  <a href="https://instagram.com/cliniativa" target="_blank" rel="noopener noreferrer" className="transition-colors duration-300 hover:text-turquoise">
                    @cliniativa
                  </a>
                </li>
              </ul>
            </div>
            <div>
              <p className="font-mono2 text-[10px] uppercase tracking-[0.3em] text-sage/50">Comece agora</p>
              <button
                data-testid="footer-cta-demo"
                onClick={() => scrollToId("demonstracao")}
                className="mt-5 rounded-full bg-turquoise px-6 py-3 text-sm font-bold text-petrol transition-[transform,box-shadow] duration-300 hover:scale-[1.03] hover:shadow-[0_10px_30px_rgba(39,179,176,0.4)]"
              >
                Agendar demonstração
              </button>
            </div>
          </div>
        </div>

        <div className="flex flex-col items-start justify-between gap-4 pt-8 sm:flex-row sm:items-center">
          <p className="text-xs text-sage/50">
            © 2026 CliniAtiva. Todos os direitos reservados. ·{" "}
            <PrivacyLink className="underline decoration-sage/40 underline-offset-2 transition-colors duration-300 hover:text-turquoise" />
          </p>
          <p className="font-mono2 text-[10px] uppercase tracking-[0.3em] text-sage/40">
            Tecnologia · Confiança · Resultado
          </p>
        </div>
      </div>
    </footer>
  );
}
